/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import RenderWhen from '../../When';
import * as S from './styles';

export interface IBannerProps {
  banner?: string;
}

export const BannerComp = ({ banner }: IBannerProps) => {
  return (
    <RenderWhen>
      <RenderWhen.If isTrue={!!banner}>
        <S.ContainerStyle backgroundImage={banner}></S.ContainerStyle>
      </RenderWhen.If>
    </RenderWhen>
  );
};

BannerComp.defaultProps = {};
